import { createTheme } from "@mui/material/styles";

// A calm, modern "stone & moss" palette suited to a shelter/outdoors inventory app.
const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#2f6f4e", light: "#5a9b78", dark: "#1f4d36" }, // moss green
    secondary: { main: "#475569" }, // slate
    background: { default: "#f4f6f5", paper: "#ffffff" },
    success: { main: "#2e7d32" },
    warning: { main: "#ed6c02" },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    h4: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
    MuiTableRow: {
      styleOverrides: {
        hover: { cursor: "pointer" },
      },
    },
  },
});

export default theme;
